import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorService } from '../errors/error.service';
import * as _ from 'lodash';
import { RequestParams } from './request-params';
import { Router } from '@angular/router';
import { ShoppingCartService } from '../shopping-cart/shopping-cart.service';
import { Observable, forkJoin } from 'rxjs';
import { EnvironmentService } from '../environment.service';

@Injectable()
export class FilePostService {
  private fileArray: File [] = new Array<File>();
  private formData: FormData;
  private httpOptions: RequestParams = {
    headers: new HttpHeaders(),
    responseType: 'text'
  };

  private readonly intakeFileUrl = '/dpwsvc/v1/ext/intake/file';
  private readonly serverName = this.environmentService.getServer();
  private recaptchaToken: string;
  private caseNumber: string;

  constructor(
    private http: HttpClient, 
    private errorService: ErrorService, 
    private router: Router,
    private cartService: ShoppingCartService, 
    private environmentService: EnvironmentService) { }

  public loadAndSendFiles(array: File[], recapcha: string, caseNum: string): void {
    this.fileArray = array.sort((a, b) => a.size - b.size);
    this.recaptchaToken = recapcha;
    this.caseNumber = caseNum;

    if (!this.fileArray || this.fileArray.length === 0) {
      this.router.navigate(['confirm']);
      this.cartService.clearCart();
    }

    this.submitFiles();
  }

  public submitFiles(): void {
    const subscriptions: Observable<any>[] = new Array<Observable<string>>();

    while (this.fileArray && this.fileArray.length > 0 ) {
      const postFileArray: File[] = new Array<File>();
      let totalMB = 0;

      for (const iterator of this.fileArray) {
        totalMB += iterator.size;
        if (totalMB < 31457280) {
          postFileArray.push(iterator);
        }
        else if (totalMB <= 41943040) {
          postFileArray.push(iterator);
          break;
        }
        else {
          break;
        }
      }

      this.fileArray = _.difference(this.fileArray, postFileArray);
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'multipart/form-data');
      this.httpOptions.headers = headers;
      this.formData = new FormData();
      this.formData.append('recaptcha', this.recaptchaToken);
      this.formData.append('case-number', this.caseNumber);

      postFileArray.forEach((element, index) => {
        this.formData.append('file' + (index + 1) , element, element.name);
      });

      const formData = this.formData;
      const httpOptions = this.httpOptions;
      subscriptions.push(this.http.post<any>(this.serverName + this.intakeFileUrl, formData,  httpOptions ));
    }

    forkJoin(subscriptions).subscribe(results => {
      let allSuccess = true;

      results.forEach(res => {
        if (!res || res !== 'SUCCESS') {
          allSuccess = false;
        }
      });

      if (allSuccess) {
        this.router.navigate(['confirm']);
        this.cartService.clearCart();
      }
      else {
        this.errorService.processError(results);
        window.scrollTo(0, 0);
      }
    }, 
    (err) => { 
      this.errorService.processError(err); 
      window.scrollTo(0, 0); 
    });
  }
}
